<template lang="pug">
.container.mt-4.mt-sm-5.mb-6
    h1.mb-4 Einstellungen

    .card.shadow-sm.mb-4
        .card-header
            ul.nav.nav-tabs.card-header-tabs
                li.nav-item: .nav-link(:class="{ active: activeTab === 'account' }", @click="activeTab = 'account'")
                    font-awesome-icon.mr-2(icon="user-cog")
                    | Mein Konto
                li.nav-item: .nav-link(:class="{ active: activeTab === 'users' }", @click="activeTab = 'users'")
                    font-awesome-icon.mr-2(icon="users")
                    | Benutzer
                    span.d-none.d-sm-inline verwaltung

        .card-body
            tab-account(v-if="activeTab === 'account'")
            tab-users(v-if="activeTab === 'users'")
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUsers, faUserCog } from '@fortawesome/free-solid-svg-icons'
import TabAccount from './Settings/Account'
import TabUsers from './Settings/Users'

library.add(faUsers, faUserCog)

export default {
    components: {
        TabAccount,
        TabUsers
    },
    data () {
        return {
            activeTab: 'account'
        }
    },
    methods: {
        gotoTab (tab) {

        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.nav-item {
    color: $primary;
    cursor: pointer;
}
</style>
